module.exports = __webpack_public_path__ + "static/media/icn_info_yellow.188f8ad5.svg";